import { configureStore } from '@reduxjs/toolkit'
import appearance from './appearance'
import layout from './layout'
import dimensions from './dimensions'
import config from './config'
import snackbars from './snackbars'
import buffer from './buffer'
import tableau from './tableau'

export const store = configureStore({
  reducer: {
    config,
    appearance,
    layout,
    dimensions,
    snackbars,
    buffer,
    tableau,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
